import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Grid, Typography, useMediaQuery } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { CustomPaginationCommon } from 'modules/Users/components';
import { useAppData } from 'context/AppContext';
import { useNavigate } from 'react-router-dom';
import theme from 'styles/theme';

const PendingVerificationTable = () => {
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(6);

  const { pendingUsers, error } = useAppData();
  const [loading, setLoading] = useState<boolean>(true);

  // ✅ Reset pagination when `pendingUsers` changes
  useEffect(() => {
    if (pendingUsers?.length > 0) {
      setPage(1);
    }
    setLoading(false);
  }, [pendingUsers]);

  if (error) {
    console.log(error);
  }

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'approve':
        return 'green';
      case 'Deactivated':
        return 'red';
      case 'Pending':
        return 'yellow';
      default:
        return '#F99F17';
    }
  };



  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const itemsPerPage = isMobile ? 4 : 6; // 4 per page on mobile, 6 on desktop



  // ✅ Pagination Logic
  const paginatedData = pendingUsers.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  const handlePageChange = (event: React.ChangeEvent<unknown>, newPage: number) => {
    setPage(newPage + 1); // Convert from 0-based index to 1-based index
  };

  const handleChangeRowsPerPage = (event: { target: { value: string } }) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleClickAccountRole = (accountRole: any, userId: string) => {
    if (accountRole === 'content-creator') {
      navigate(`/manage-users/${accountRole}/${userId}`);
    } else if (accountRole === 'standard-user') {
      navigate(`/admin/${accountRole}/${userId}`);
    } else {
      console.log('User type not found');
    }
  };



  return (
    <Grid
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'center'}
      gap={5}
      px={5}
    // mb={5}
    >
      <Box pt={5} fontWeight={500} fontSize={'28px'} color={'#233F91'}>
        Pending Verifications
      </Box>
      <Grid item xs={10}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '35px' }}>
          <div
            style={{
              backgroundColor: '#EFF4FA',
              borderRadius: '15px',
              padding: '24px',
              display: 'flex',
              justifyContent: 'space-between',
              color: '#6A6A6A',
              fontFamily: 'Atten Round New',
            }}>
            <div
              style={{ fontWeight: '700', fontSize: '17px', width: '12.5%' }}>
              Name
            </div>

            <div
              style={{ fontWeight: '700', fontSize: '17px', width: '12.5%' }}>
              {' '}
              Email Address
            </div>
            <div
              style={{ fontWeight: '700', fontSize: '17px', width: '12.5%' }}>
              License Expiration
            </div>
            <div
              style={{ fontWeight: '700', fontSize: '17px', width: '12.5%' }}>
              Insurance Expiration
            </div>
            <div
              style={{ fontWeight: '700', fontSize: '17px', width: '12.5%' }}>
              Account Role
            </div>
            <div
              style={{ fontWeight: '700', fontSize: '17px', width: '12.5%' }}>
              Account Status
            </div>
          </div>
          <div
            style={{
              backgroundColor: '#fff',
              borderRadius: '15px',
              padding: '24px',
              display: 'flex',
              flexDirection: 'column',
              gap: '28px',
            }}>
            {loading ? (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="40vh"
              // width="100vw"
              >
                <CircularProgress color="primary" size={60} />
              </Box>
            ) : paginatedData.length === 0 ? (
              <Box
                flex={1}
                display="flex"
                alignItems={"center"}
                justifyContent={"center"}
              // width="100vw"
              >
                <Typography
                  display="flex"
                  alignItems="center"
                  fontSize={22}
                  color="#797979"
                  fontWeight={400}
                >
                  No users found.
                </Typography>
              </Box>
            ) : (
              paginatedData.map((user) => (

                // ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)

                <div
                  onClick={() => handleClickAccountRole(user.type, user.id)}
                  key={user.id}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    // fontSize: '19px',
                    fontWeight: '500 !important',
                    color: '#595959',
                    lineHeight: '24px',
                    fontFamily: 'Atten Round New !important',
                  }}>
                  <div style={{ width: '12.5%', cursor: 'pointer' }}>{user.firstName}</div>
                  <div style={{ width: '12.5%', cursor: 'pointer' }}>{user.email}</div>
                  <div style={{ width: '12.5%', cursor: 'pointer' }}>
                    {/* {user.License} */}
                    {new Date(user?.licenseExpiration?.seconds * 1000).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit'
                    })}
                  </div>
                  <div style={{ width: '12.5%', cursor: 'pointer' }}>
                    {/* {user.Insurance} */}
                    {new Date(user?.insuranceExpiration?.seconds * 1000).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit'
                    })}
                  </div>
                  <div style={{ width: '12.5%', cursor: 'pointer' }}>{user.type}</div>
                  <div style={{ width: '12.5%', cursor: 'pointer' }}>
                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                      <Box component='span' sx={{ color: 'inherit', cursor: 'pointer' }}>
                        {user.accountStatus}
                      </Box>
                      <FiberManualRecordIcon
                        fontSize='small'
                        sx={{
                          color: getStatusColor(
                            user ? user?.accountStatus : ''
                          ),
                        }}
                      />
                    </Box>
                  </div>
                </div>
              ))
            )}
            <div
              style={{
                marginTop: '20px',
                display: 'flex',
                justifyContent: 'center',
              }}>
              {/* <CustomPaginationCommon
                count={pendingUsers?.length}
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              /> */}
              <CustomPaginationCommon
                count={pendingUsers?.length}
                page={page - 1}
                rowsPerPage={itemsPerPage}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

export default PendingVerificationTable;
